export const safeVideoHref = (url) => (/^https?:\/\//.test(url) ? url : '#');

export const VideoHosts = {
    YOUTUBE: 'youtube',
    VIMEO: 'vimeo',
    HUDL: 'hudl',
    OTHER: 'other',
};

export const resolveVideoHost = (url) => {
    if (typeof url !== 'string' || url.trim().length === 0) {
        return VideoHosts.OTHER;
    }
    try {
        const parsed = new URL(url.trim());
        const host = parsed.hostname.toLowerCase().replace(/^www\./, '');
        if (host === 'youtube.com' || host === 'youtu.be' || host.endsWith('.youtube.com')) {
            return VideoHosts.YOUTUBE;
        }
        if (host === 'vimeo.com' || host.endsWith('.vimeo.com')) {
            return VideoHosts.VIMEO;
        }
        if (host === 'hudl.com' || host.endsWith('.hudl.com')) {
            return VideoHosts.HUDL;
        }
        return VideoHosts.OTHER;
    } catch {
        return VideoHosts.OTHER;
    }
};
